module.exports = __webpack_public_path__ + "static/lottery-72f346dfc0708a1bc31eb447124e8a77.jpg";